import type { EducatorSubject, GradeLevel } from '@/lib/schemas/tutor-profile';

export interface Filters {
  subject: EducatorSubject | '';
  gradeLevel: GradeLevel | '';
  name: string;
  language: string;
  gender: string;
  minHourlyInr: string;
  maxHourlyInr: string;
}

export const PAGE_SIZE = 20;
export const SEARCH_DEBOUNCE_MS = 500;

export const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  hi: 'Hindi',
  ta: 'Tamil',
  te: 'Telugu',
  kn: 'Kannada',
  ml: 'Malayalam',
  mr: 'Marathi',
  bn: 'Bengali',
  gu: 'Gujarati',
  pa: 'Punjabi',
  ur: 'Urdu',
  fr: 'French',
  es: 'Spanish',
  de: 'German',
  ar: 'Arabic',
  zh: 'Chinese',
};

export const GENDER_LABELS: Record<string, string> = {
  male: 'Male',
  female: 'Female',
  non_binary: 'Non-binary',
  prefer_not_to_say: 'Prefer not to say',
};
